let setnull = (str) => {
  if (str !== undefined && str !== null && str !== '') {
    return str
  } else {
    return '-'
  }
}

export default {
  setnull
}



// WEBPACK FOOTER //
// ./src/utils/setnull.js